import * as React from "react";
import {Grid, Menu, Button, IconButton, MenuItem, Box} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import AccountCircle from "@mui/icons-material/AccountCircleOutlined";
import {useMsal} from "@azure/msal-react";
import {AuthenticatedTemplate} from "@azure/msal-react";
import {useLocation, Link} from "react-router-dom";
import logo from "../../assets/images/AustGov_IA_inline_pos.svg";
import GD from "../../assets/images/IA_GraphicDevice.svg";

const styles = {
	button: {
		fontSize: "20px"
	}
};

export default function Topbar() {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const [ppath, setPpath] = React.useState("");
	const location = useLocation();
	React.useEffect(() => {
		setPpath(window.location.pathname);
	}, [location]);
	const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};

	const {instance, accounts} = useMsal();
	const logoutRedirect = () => {
		instance.logoutRedirect();
	};
	return (
		<AppBar
			color={"transparent"}
			elevation={0}
			sx={{zIndex: "100", position: "relative"}}>
			<Toolbar>
				<Grid
					container
					spacing={2}
					alignItems="center"
				>
					<Grid item xs={3}>
						<Box
							component={Link}
							to="/"
						>
							<Box
								component="img"
								sx={{
									height: "150%",
									maxHeight: 50,
									pt: 1
								}}
								alt="Logo"
								src={logo}
							/>
						</Box>
					</Grid>
					<Grid item xs={8}>
						<AuthenticatedTemplate>
							<Grid
								container spacing={2}
								justifyContent="flex-end"
							>
								<Grid item>
									<Button
										variant={ppath === "/national-modelling" ? "contained" : "text"}
										style={styles.button}
										 sx={{
                                            ":hover": {
//                                                 bgcolor: "white",
                                                textDecoration: "underline"
                                            }
                                          }}
										component={Link} to={"/national-modelling"}
									>
										NATIONAL PIPELINE
									</Button>
								</Grid>
								<Grid item>
									<Button
										variant={ppath === "/state-modelling" ? "contained" : "text"}
										style={styles.button}
										sx={{
                                            ":hover": {
//                                                 bgcolor: "white",
                                                textDecoration: "underline"
                                            }
                                          }}
										component={Link} to={"/state-modelling"}
									>
										STATE PIPELINE
									</Button>
								</Grid>
								<Grid item>
									<Button
										variant={ppath === "/scenario-modelling" ? "contained" : "text"}
										component={Link}
										to={"/scenario-modelling"}
										style={styles.button}
										sx={{
                                            ":hover": {
//                                                 bgcolor: "white",
                                                textDecoration: "underline"
                                            }
                                          }}
									>
										PIPELINE SIMULATOR
									</Button>
								</Grid>
								<Grid item>
									<Button
										variant={ppath === "/national-map" ? "contained" : "text"}
										sx={{
                                            ":hover": {
//                                               bgcolor: "white",
                                              textDecoration: "underline"
                                            }
                                          }}
										component={Link}
										to={"/national-map"}
										style={styles.button}
									>
										NATIONAL MAP
									</Button>
								</Grid>
								<Grid item>
									<Button
										variant={ppath === "/glossary" ? "contained" : "text"}
										sx={{
                                            ":hover": {
//                                               bgcolor: "white",
                                              textDecoration: "underline"
                                            }
                                          }}
										component={Link}
										to={"/glossary"}
										style={styles.button}
									>
										GLOSSARY
									</Button>
								</Grid>
								<Grid item>
									<Button
										variant={ppath === "/FAQ" ? "contained" : "text"}
										sx={{
                                            ":hover": {
//                                               bgcolor: "white",
                                              textDecoration: "underline"
                                            }
                                          }}
										component={Link}
										to={"/FAQ"}
										style={styles.button}
									>
										FAQ
									</Button>
								</Grid>
								<Grid item>
									<IconButton
										size="large"
										aria-label="account of current user"
										aria-controls="menu-appbar"
										aria-haspopup="true"
										onClick={handleMenu}
										color="inherit"
									>
										<AccountCircle/>
									</IconButton>
									<Menu
										id="menu-appbar"
										anchorEl={anchorEl}
										anchorOrigin={{
											vertical: "top",
											horizontal: "right",
										}}
										keepMounted
										transformOrigin={{
											vertical: "top",
											horizontal: "right",
										}}
										open={Boolean(anchorEl)}
										onClose={handleClose}
									>
										<MenuItem
											onClick={handleClose}>{accounts[0] ? accounts[0].username : ""}</MenuItem>
										<MenuItem onClick={handleClose}>{accounts[0] ? accounts[0].name : ""}</MenuItem>
										<MenuItem onClick={logoutRedirect}>Logout</MenuItem>
									</Menu>
								</Grid>
							</Grid>
						</AuthenticatedTemplate>
					</Grid>
					<Box
						component="img"
						sx={{
							height: "300%",
							maxHeight: 200,
							display: "flex", zIndex: "0", position: "fixed", top: 0, right: 0
						}}
						src={GD}
					/>
				</Grid>
			</Toolbar>

		</AppBar>
	);
}
